import axios from "axios";
import {sha256} from "./sha256";

export const apiBaseUrl = process.env.MIX_PARTNER_API_URL || '';

function endpoint(path) {
    return apiBaseUrl + '/api/' + path;
}

async function partners(zip, radius, categories) {
    const params = {};

    if (zip) params.zip = zip;
    if (radius) params.radius = radius;
    if (categories) params.category = categories.map(category => category.id);

    try {
        const response = await axios.get(endpoint('partners'), {params});

        return response.data;
    } catch (error) {
        return null;
    }
}

async function categories() {
    try {
        const response = await axios.get(endpoint('categories'));

        return response.data;
    } catch (error) {
        return [];
    }
}

async function locations(search) {
    try {
        const response = await axios.get(
            endpoint('locations'),
            {
                params: {
                    s: search
                }
            }
        );

        return response.data;
    } catch (error) {
        return null;
    }
}

function getPollHash() {
    let hash = window.localStorage.getItem('sfAmeckePollHash');

    if (hash) {
        return hash;
    }

    hash = sha256("sfAmeckePoll" + Math.random());
    window.localStorage.setItem('sfAmeckePollHash', hash);

    return hash;
}

function hasSubmittedPoll() {
    return window.localStorage.getItem('sfAmeckePollSent');
}

async function poll(data) {
    data.hash = getPollHash();

    await axios.post(
        endpoint('partner-poll'),
        data
    );

    window.localStorage.setItem('sfAmeckePollSent', true);
}

export default {
    partners,
    categories,
    locations,
    poll,
    hasSubmittedPoll,
};
